import { TChangePasswordForm, TSignInForm, TSignUpForm } from '~/modules/auth/types.ts';

export const initialValuesSignUp: TSignUpForm = {
  username: '',
  password: '',
  repeatPassword: '',
  email: '',
  phone: '',
  checkConsentToDataProcessing: false,
};

export const initialValuesChangePassword: TChangePasswordForm = {
  newPassword: '',
  repeatPassword: '',
};

export const initialValuesSignIn: TSignInForm = {
  username: '',
  password: '',
};
